import Vue from "vue";
import App from "./App.vue";
import "./vue-msal.js";
import ApiService from "./http/axios";
import router from "./router";
import store from "./store";
import moment from "moment";

import Button from "primevue/button";
// import InputText from "primevue/inputtext";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";

Vue.use(ToastService);

// Vue.component("InputText", InputText);
Vue.component("Button", Button);
Vue.component("Toast", Toast);

import "primevue/resources/themes/nova-accent/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import FileUpload from "primevue/fileupload";
import Card from "primevue/card";

import { ADMIN, SHAREHOLDER } from "./constants/user-groups";

ApiService.init();

Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("MM/DD/YYYY hh:mm");
  }
});

Vue.filter("ordinalSuffix", function(i) {
  return i
});

Vue.mixin({
  methods: {
    ordinalSuffix(i) {
      return i
    },
    isAdmin: function() {
      try {
        let groups = this.$msal.data.user.idTokenClaims.groups;

        return groups.includes(ADMIN);
      } catch (e) {
        console.error(e);
        return false;
      }
    },
    isShareholder: function() {
      try {
        let groups = this.$msal.data.user.idTokenClaims.groups;

        return groups.includes(SHAREHOLDER);
      } catch (e) {
        console.error(e);
        return false;
      }
    }
  }
});

Vue.component("FileUpload", FileUpload);
Vue.component("Card", Card);

new Vue({
  router,
  store,
  el: "#app",
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js